/**
 * CJSUSPENSION model and upgrade page guidance.
 * Keeps the bottom of every model page consistent:
 * Performance Upgrades -> Before You Book -> courier logistics -> final booking CTA.
 */
(function () {
  'use strict';

  var workshopDirectionsUrl = 'https://maps.app.goo.gl/zqapEz3364qriWtw9';

  function normalise(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function addStyles() {
    if (document.getElementById('cjs-model-booking-guidance-styles')) return;

    var style = document.createElement('style');
    style.id = 'cjs-model-booking-guidance-styles';
    style.textContent = [
      '.cjs-before-book-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:18px}',
      '.cjs-before-book-card{position:relative;padding:24px;border:1px solid var(--cjs-border,#e6e2dd);border-radius:12px;background:#fff;overflow:hidden}',
      '.cjs-before-book-card:before{content:"";position:absolute;top:0;left:0;width:72px;height:3px;background:var(--cjs-red,#a8323a)}',
      '.cjs-before-book-card h3{margin:0 0 10px;color:var(--cjs-black,#111);font-size:20px;font-weight:850;line-height:1.2}',
      '.cjs-before-book-card p{margin:0;color:var(--cjs-muted,#666);font-size:14px;line-height:1.65}',
      '.cjs-courier-steps{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:14px;margin:4px 0 22px}',
      '.cjs-courier-step{position:relative;padding:20px 20px 20px 58px;border:1px solid var(--cjs-border,#e6e2dd);border-radius:12px;background:#fff}',
      '.cjs-courier-step__number{position:absolute;top:20px;left:18px;display:flex;align-items:center;justify-content:center;width:28px;height:28px;border-radius:50%;background:var(--cjs-red,#a8323a);color:#fff;font-size:13px;font-weight:900}',
      '.cjs-courier-step h3{margin:0 0 7px;color:var(--cjs-black,#111);font-size:18px;font-weight:850;line-height:1.2}',
      '.cjs-courier-step p{margin:0;color:var(--cjs-muted,#666);font-size:14px;line-height:1.6}',
      '.cjs-upgrade-good-to-know-grid{grid-template-columns:repeat(auto-fit,minmax(250px,1fr))!important}',
      '.cjs-upgrade-good-to-know-grid .cjs-upgrade-support-card{height:100%}',
      '@media(max-width:800px){.cjs-before-book-grid,.cjs-courier-steps{grid-template-columns:1fr}}'
    ].join('');

    document.head.appendChild(style);
  }

  function makeBeforeBookCard(title, text) {
    var card = document.createElement('article');
    card.className = 'cjs-before-book-card';

    var heading = document.createElement('h3');
    heading.textContent = title;

    var copy = document.createElement('p');
    copy.textContent = text;

    card.appendChild(heading);
    card.appendChild(copy);
    return card;
  }

  function makeBeforeBookGrid(page) {
    var grid = document.createElement('div');
    grid.className = 'cjs-before-book-grid';
    grid.appendChild(makeBeforeBookCard('Exact Model & Generation', identificationText(page)));
    grid.appendChild(makeBeforeBookCard(
      'Parts & Additional Work',
      'Every unit is inspected during servicing. If extra parts or repair work are required, we will confirm the work before proceeding unless you selected an additional-work allowance on the booking form.'
    ));
    grid.appendChild(makeBeforeBookCard(
      'Symptoms, Setup & Goals',
      'Tell us about leaks, noises, play, poor damping or setup concerns, and include any tuning or upgrade goals. This helps us inspect the right areas and return a useful baseline setup.'
    ));
    return grid;
  }

  function makeCourierStep(number, title, text) {
    var card = document.createElement('article');
    card.className = 'cjs-courier-step';

    var badge = document.createElement('span');
    badge.className = 'cjs-courier-step__number';
    badge.textContent = number;

    var heading = document.createElement('h3');
    heading.textContent = title;

    var copy = document.createElement('p');
    copy.textContent = text;

    card.appendChild(badge);
    card.appendChild(heading);
    card.appendChild(copy);
    return card;
  }

  function makeDirectionsButton() {
    var button = document.createElement('a');
    button.className = 'cjs-model-button secondary';
    button.href = workshopDirectionsUrl;
    button.target = '_blank';
    button.rel = 'noopener noreferrer';
    button.textContent = 'Get Directions to CJSUSPENSION';
    return button;
  }

  function modelName(page) {
    var heading = page.querySelector('.cjs-model-hero h1');
    var name = String(heading ? heading.textContent : 'Suspension')
      .replace(/\s+/g, ' ')
      .trim();

    name = name.replace(/\s+Service New Zealand$/i, '');
    return name || 'Suspension';
  }

  function identificationText(page) {
    var eyebrow = normalise((page.querySelector('.cjs-model-eyebrow') || {}).textContent);
    var heading = normalise((page.querySelector('.cjs-model-hero h1') || {}).textContent);

    if (eyebrow.indexOf('fork servicing') !== -1 || heading.indexOf(' fork ') !== -1) {
      return 'Send the exact fork model, production year or generation, travel and damper version where known. Clear photos of the top caps and serial or ID markings help with older or uncertain versions.';
    }

    if (eyebrow.indexOf('dropper servicing') !== -1 || heading.indexOf('dropper') !== -1) {
      return 'Send the exact dropper model and generation, post diameter and travel. Clear photos of the post and identification markings help where the exact version is uncertain.';
    }

    if (
      eyebrow.indexOf('rear shock servicing') !== -1 ||
      eyebrow.indexOf('rear air shock servicing') !== -1 ||
      heading.indexOf('shock') !== -1
    ) {
      return 'Send the exact shock model and generation, eye-to-eye length, stroke and bike model. For coil shocks, include the spring rate where known.';
    }

    return 'Send the exact suspension model, production year or generation, key dimensions and clear identification photos so we can confirm the correct service and parts before work begins.';
  }

  function findExistingBeforeBook(page) {
    var marked = page.querySelector('[data-cjs-before-book="true"]');
    if (marked) return marked;

    var headings = Array.prototype.slice.call(page.querySelectorAll('.cjs-model-section-head h2'));
    var match = headings.find(function (heading) {
      return normalise(heading.textContent) === 'before you book';
    });

    if (!match) return null;

    var section = match.closest('.cjs-model-section');
    if (section) section.setAttribute('data-cjs-before-book', 'true');
    return section;
  }

  function createBeforeBookSection(page) {
    var wrap = page.querySelector('.cjs-model-wrap');
    if (!wrap) return null;

    addStyles();

    var section = document.createElement('section');
    section.className = 'cjs-model-section';
    section.setAttribute('data-cjs-before-book', 'true');

    var panel = document.createElement('div');
    panel.className = 'cjs-model-panel';

    var header = document.createElement('div');
    header.className = 'cjs-model-section-head';

    var heading = document.createElement('h2');
    heading.textContent = 'Before You Book';

    var intro = document.createElement('p');
    intro.textContent = 'A few details help us confirm the correct service, parts and workshop requirements before your suspension arrives.';

    header.appendChild(heading);
    header.appendChild(intro);
    panel.appendChild(header);
    panel.appendChild(makeBeforeBookGrid(page));
    section.appendChild(panel);

    var finalCta = page.querySelector('.cjs-model-final-cta');
    var finalSection = finalCta ? finalCta.closest('.cjs-model-section') : null;

    if (finalSection && finalSection.parentNode === wrap) {
      wrap.insertBefore(section, finalSection);
    } else {
      wrap.appendChild(section);
    }

    return section;
  }

  function ensureBeforeBook() {
    document.querySelectorAll('.cjs-model-service').forEach(function (page) {
      if (findExistingBeforeBook(page)) return;

      var faq = page.querySelector('.cjs-model-faq');
      if (!faq) {
        createBeforeBookSection(page);
        return;
      }

      var section = faq.closest('.cjs-model-section');
      var panel = section ? section.querySelector('.cjs-model-panel') : null;
      var header = panel ? panel.querySelector('.cjs-model-section-head') : null;

      if (!section || !panel || !header) {
        createBeforeBookSection(page);
        return;
      }

      section.setAttribute('data-cjs-before-book', 'true');
      addStyles();

      var heading = header.querySelector('h2');
      if (heading) heading.textContent = 'Before You Book';

      var intro = header.querySelector('p');
      if (!intro) {
        intro = document.createElement('p');
        header.appendChild(intro);
      }
      intro.textContent = 'A few details help us confirm the correct service, parts and workshop requirements before your suspension arrives.';

      faq.replaceWith(makeBeforeBookGrid(page));
    });
  }

  function replaceCourierSection() {
    document.querySelectorAll('.cjs-model-service').forEach(function (page) {
      if (page.querySelector('[data-cjs-courier-logistics="true"]')) return;

      var section = null;
      Array.prototype.slice.call(page.querySelectorAll('.cjs-model-section')).some(function (candidate) {
        if (candidate.querySelector('.cjs-model-final-cta')) return false;

        var heading = candidate.querySelector('.cjs-model-section-head h2');
        var title = normalise(heading ? heading.textContent : '');

        if (title.indexOf('from anywhere in new zealand') !== -1 || title.indexOf('send your ') === 0) {
          section = candidate;
          return true;
        }
        return false;
      });

      if (!section) return;

      var panel = section.querySelector('.cjs-model-panel');
      var header = panel ? panel.querySelector('.cjs-model-section-head') : null;
      var heading = header ? header.querySelector('h2') : null;
      if (!panel || !header || !heading) return;

      section.setAttribute('data-cjs-courier-logistics', 'true');
      addStyles();

      heading.textContent = 'Sending Your ' + modelName(page) + ' to CJSUSPENSION';

      var intro = header.querySelector('p');
      if (!intro) {
        intro = document.createElement('p');
        header.appendChild(intro);
      }
      intro.textContent = 'Book your service, then choose the easiest way to get your suspension to our Queenstown workshop.';

      var existingSteps = panel.querySelector('.cjs-courier-steps');
      if (existingSteps) existingSteps.remove();

      var steps = document.createElement('div');
      steps.className = 'cjs-courier-steps';
      steps.appendChild(makeCourierStep('1', 'Book Your Service', 'Complete the online booking first so we know what is arriving and what you would like us to check.'));
      steps.appendChild(makeCourierStep('2', 'Pack It Securely', 'Protect the suspension so it cannot move around in the box. Include any parts we have asked you to send with it.'));
      steps.appendChild(makeCourierStep('3', 'Send or Drop Off', 'Use our courier instructions for tracked shipping, or drop it into our Queenstown workshop if you are local.'));

      var buttonRow = panel.querySelector('.cjs-model-button-row');
      if (!buttonRow) {
        buttonRow = document.createElement('div');
        buttonRow.className = 'cjs-model-button-row';
        panel.appendChild(steps);
        panel.appendChild(buttonRow);
      } else {
        panel.insertBefore(steps, buttonRow);
      }

      var buttons = Array.prototype.slice.call(buttonRow.querySelectorAll('a.cjs-model-button'));
      var courierButton = buttons[0];

      if (!courierButton) {
        courierButton = document.createElement('a');
        buttonRow.appendChild(courierButton);
      }

      courierButton.className = 'cjs-model-button';
      courierButton.href = '/pages/send-suspension-by-courier';
      courierButton.textContent = 'View Courier Instructions';
      courierButton.removeAttribute('target');
      courierButton.removeAttribute('rel');

      buttons.slice(1).forEach(function (button) {
        button.remove();
      });

      buttonRow.appendChild(makeDirectionsButton());
    });
  }

  function simplifyFinalCta() {
    document.querySelectorAll('.cjs-model-service').forEach(function (page) {
      var cta = page.querySelector('.cjs-model-final-cta');
      if (!cta || cta.getAttribute('data-cjs-final-booking') === 'true') return;

      cta.setAttribute('data-cjs-final-booking', 'true');

      var heading = cta.querySelector('h2');
      var copy = cta.querySelector('p');

      if (heading) heading.textContent = 'Ready to Book Your ' + modelName(page) + ' Service?';
      if (copy) copy.textContent = 'Book online and tell us the exact model, generation and any issues, setup changes or upgrades you would like us to check.';
    });
  }

  function orderBottomJourney() {
    document.querySelectorAll('.cjs-model-service').forEach(function (page) {
      var beforeBook = page.querySelector('[data-cjs-before-book="true"]');
      var courier = page.querySelector('[data-cjs-courier-logistics="true"]');
      var finalCta = page.querySelector('.cjs-model-final-cta');
      var finalSection = finalCta ? finalCta.closest('.cjs-model-section') : null;
      var wrap = page.querySelector('.cjs-model-wrap');

      if (!wrap || !beforeBook) return;

      var upgradeSections = [];
      Array.prototype.slice.call(page.querySelectorAll('.cjs-model-upgrade-grid')).forEach(function (grid) {
        var section = grid.closest('.cjs-model-section');
        if (!section || section.parentNode !== wrap || upgradeSections.indexOf(section) !== -1) return;
        upgradeSections.push(section);
      });

      upgradeSections.forEach(function (section) {
        if (section.nextElementSibling !== beforeBook) {
          wrap.insertBefore(section, beforeBook);
        }
      });

      if (courier) {
        if (beforeBook.nextElementSibling !== courier) {
          wrap.insertBefore(beforeBook, courier);
        }
        if (finalSection && courier.nextElementSibling !== finalSection) {
          wrap.insertBefore(courier, finalSection);
        }
      } else if (finalSection && beforeBook.nextElementSibling !== finalSection) {
        wrap.insertBefore(beforeBook, finalSection);
      }
    });
  }

  function replaceUpgradeFaqs() {
    document.querySelectorAll('.cjs-upgrade-faqs').forEach(function (faqs) {
      if (faqs.getAttribute('data-cjs-good-to-know') === 'true') return;

      var details = Array.prototype.slice.call(faqs.querySelectorAll('details.cjs-upgrade-faq'));
      if (!details.length) return;

      var panel = faqs.closest('.cjs-upgrade-panel');
      var header = panel ? panel.querySelector('.cjs-upgrade-section-head') : null;
      if (!panel || !header) return;

      addStyles();

      var kicker = header.querySelector('.cjs-upgrade-kicker');
      var heading = header.querySelector('h2');
      if (kicker) kicker.textContent = 'Useful ownership information';
      if (heading) heading.textContent = 'Good to Know';

      var grid = document.createElement('div');
      grid.className = 'cjs-upgrade-support-grid cjs-upgrade-good-to-know-grid';
      grid.setAttribute('data-cjs-good-to-know', 'true');

      details.forEach(function (detail) {
        var card = document.createElement('article');
        card.className = 'cjs-upgrade-support-card';

        var cardHeading = document.createElement('h3');
        var summary = detail.querySelector('summary');
        cardHeading.textContent = summary ? summary.textContent.trim() : 'Good to Know';

        var body = document.createElement('div');
        body.className = 'rte';
        var sourceBody = detail.querySelector('.rte');
        if (sourceBody) body.innerHTML = sourceBody.innerHTML;

        card.appendChild(cardHeading);
        card.appendChild(body);
        grid.appendChild(card);
      });

      faqs.replaceWith(grid);
    });
  }

  function run() {
    ensureBeforeBook();
    replaceCourierSection();
    simplifyFinalCta();
    orderBottomJourney();
    replaceUpgradeFaqs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);

  var observer = new MutationObserver(function () {
    run();
  });

  if (document.documentElement) {
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();